@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.dangerous-goods-type-field {
  font-weight: @normal;
}

.dropdown-menu {
  margin-left: @space-8;
}
